const setupPlaceholders = (form) => {
  form.querySelectorAll('label[for]').forEach((label) => {
    try {
      const field = form.querySelector(`#${label.getAttribute('for')}`)

      if (field && ['text', 'email', 'tel', 'textarea', 'number'].includes(field.type)) {
        field.placeholder = label.innerText
        label.classList.add('sr-only')
      }
    } catch {
      console.error(label)
    }
  })
}

const setupDropdowns = async (form) => {
  const dropdowns = form.querySelectorAll('select')

  if (!dropdowns.length) {
    return
  }

  const { default: easydropdown } = await import('easydropdown-a11y')
  import('@styles/components/dropdown.css')

  dropdowns.forEach((el) => {
    const select = el

    if (!select) {
      return
    }

    const placeholder = el.querySelector('option[value=""]')
    const label = form.querySelector(`label[for="${select.id}"]`)

    if (placeholder && !placeholder.hasAttribute('data-placeholder')) {
      placeholder.setAttribute('data-placeholder', true)
    }

    if (label) {
      placeholder.textContent = label.innerText
      label.classList.add('sr-only')
    } else {
      placeholder.textContent = 'Select One'
    }

    const opts = {
      behavior: {
        openOnFocus: true,
        maxVisibleItems: 5,
        liveUpdates: true,
        useNativeUiOnMobile: false,
      },
    }

    easydropdown(select, opts)
  })
}

const handleContact = (form) => {
  if (form.classList.contains('bloomerang-form--contact')) {
    const field = form.querySelector('#CustomInteractionField_154624')
    const params = new URL(window.location).searchParams

    if (params.has('subject')) {
      const subject = params.get('subject')
      field.querySelectorAll('option').forEach((option) => {
        if (option.textContent === subject) {
          option.selected = true
        }
      })
    }
  }
}

const handleEndow = (form) => {
  if (form.classList.contains('bloomerang-form--endow')) {
    const field = form.querySelector('.section.donation .field.radio [name="donation-level"]')

    if (field) {
      setTimeout(() => {
        field.click()
      }, 500)
    }
  }
}

const handleGardenTour = (form) => {
  if (form.classList.contains('garden-tour')) {
    const field = form.querySelector('.section.comment .field.comment textarea')

    if (field) {
      field.setAttribute('placeholder', 'Please describe your garden.')
    }
  }
}

const init = (form) => {
  form.classList.add('is-init')

  setupPlaceholders(form)
  setupDropdowns(form)

  handleContact(form)
  handleEndow(form)
  handleGardenTour(form)
}

const form = document.querySelector('.bloomerang-form')

if (form) {
  const observer = new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        init(form)
        observer.disconnect()
      }
    }
  })

  observer.observe(form, {
    childList: true,
  })
}
